/* eslint-disable */
<template>
  <!-- -------------ChecKout------------------ -->
  <div class="container-fluid pt-5 pb-5 bg-light">
    <h4>BILLING DETIALS</h4>
    <div class="underline-green"></div>
    <br />
    <div class="container-fluid">
      <div class="App" v-if="paystackPayment && checkoutInfo">
        <div class="card card-body mb-4">
          <ul class="list-group">
            <li class="list-group-item">
              <b>Fullname:</b>
              {{ this.$store.state.firstname }}
              {{ this.$store.state.lastname }}
            </li>
            <li class="list-group-item">
              <b>E-mail:</b>
              {{ this.$store.state.email }}
            </li>
            <li class="list-group-item">
              <b>Amount:</b>
              {{ addComma(this.$store.state.amount / 100) }}
            </li>
            <li class="list-group-item">
              <b>payment Method:</b> Debit/Credit (Paystack)
            </li>
          </ul>
          <p class="my-4">
            Thank you for your order, please click on "Proceed with payment"
            below to pay with paystack.
          </p>
        </div>
        <div class="App-intro">
          <paystack
            :accessCode="accessCode"
            :ref="reference"
            :paystackkey="paystackkey"
            :reference="reference"
            :callback="callback"
            :close="close"
            :embed="false"
          >
            <i>PROCEED WITH PAYMENT</i>
          </paystack>
          <button type="button" @click="cancelTransaction" class="checkout_btn btn btn-danger">
            <span
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
              v-if="processingClearCart"
            ></span>
            CANCEL TRANSACTION
          </button>
        </div>
      </div>
      <form
        @submit.prevent="submitBillingForm"
        novalidate="true"
        v-if="!paystackPayment && !checkoutInfo"
      >
        <div class="row">
          <div class="form-group col-md-6">
            <label>
              First name
              <span class="form-required">*</span>
            </label>
            <input type="text" class="form-control" placeholder="First Name" v-model="firstname" />
          </div>
          <div class="form-group col-md-6">
            <label>
              Last name
              <span class="form-required">*</span>
            </label>
            <input type="text" class="form-control" placeholder="Last Name" v-model="lastname" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="form-group col-md-6">
            <label>Company name (optional)</label>
            <input type="text" class="form-control" placeholder="Company Name" v-model="company" />
          </div>
          <div class="form-group col-md-6">
            <label>Country</label>
            <input type="text" class="form-control" value="Nigeria" readonly />
          </div>
        </div>
        <div class="row mt-4">
          <div class="form-group col-md-6">
            <label>
              State
              <span class="form-required">*</span>
            </label>
            <select id="state" class="form-control" v-model="state">
              <option v-for="state in states" :key="state" :value="state">{{state}}</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label>
              Town/City
              <span class="form-required">*</span>
            </label>
            <input type="text" class="form-control" v-model="city" placeholder="City" />
          </div>
        </div>
        <div class="row mt-4">
          <div class="form-group col-md-6">
            <label>
              Street Address
              <span class="form-required">*</span>
            </label>
            <input type="text" v-model="address" class="form-control" placeholder="First Name" />
          </div>
          <div class="form-group col-md-6">
            <label>Apartment (optional)</label>
            <input
              type="text"
              class="form-control"
              v-model="appartment"
              placeholder="Apartment, suit, unit etc..."
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="form-group col-md-6">
            <label>
              Email
              <span class="form-required">*</span>
            </label>
            <input type="email" class="form-control" v-model="email" placeholder="E-mail address" />
          </div>
          <div class="form-group col-md-6">
            <label>Phone</label>
            <input type="tel" v-model="phone" class="form-control" placeholder="Mobile number" />
          </div>
        </div>

        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Products</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in cart" :key="item.product.id">
              <td>{{ item.product.name }}</td>
              <td>&#8358;{{ addComma(item.product.price * item.quantity) }}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <strong>Subtotal</strong>
                <span class="pl-2">&#8358;{{ addComma(cartTotalPrice) }}</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <strong>Taxes</strong>
                <span class="pl-2">&#8358;{{ addComma(taxAmount) }}</span>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <strong>Total</strong>
                <span class="pl-2">&#8358;{{ addComma(cartTotalPrice + taxAmount) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <ul class="float-right" v-if="billingErroes.length">
          <li
            class="text-danger pl-2"
            style="margin-left: 12px; text-align: left;"
            v-for="error in billingErroes"
            :key="error"
          >{{ error }}</li>
        </ul>
        <div class="clear"></div>
        <div class="form-group mt-4 text-right">
          <button type="submit" class="checkout_btn btn btn-success">
            <span
              class="spinner-border spinner-border-sm mr-2"
              role="status"
              aria-hidden="true"
              v-if="processing"
            ></span>
            PLACE ORDER
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Paystack from "../components/Paystack";
export default {
  name: "Checkout",
  components: {
    Paystack
  },
  beforeRouteLeave(to, from, next) {
    if (confirm("Do you want to cancel Transaction?")) {
      this.cancelTransaction();
      next();
    }
  },
  computed: {
    cart() {
      return this.$store.state.cart;
    },
    // GET LIST OF STATES
    states() {
      return this.$store.state.states;
    },
    // GET CART TOTAL PRICE
    cartTotalPrice() {
      return this.$store.getters.cartTotalPrice;
    },
    // GET STATE CHECKOUT INFO
    checkoutInfo() {
      return this.$store.getters.checkoutInfo;
    },
    // GET STATE CHECKOUT VALUE
    checkout() {
      return this.$store.getters.checkout;
    },
    // GET STATE PAYMENT STATUS
    paystackPayment() {
      return this.$store.getters.paystackPayment;
    },
    // TAX
    taxAmount() {
      let tax = (this.cartTotalPrice * 10) / 600;
      let taxAmount = Math.trunc(tax);
      return taxAmount;
    },
    // GENERATE REFERNCE NUMBER AFTER PAYMENT
    genReference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    }
  },
  mounted() {
    this.$store.state.showSearch = false;
  },
  // REDIRECT USER IF HE HAS NO ACCESS TO THE PAGE
  beforeCreate() {
    if (this.$store.state.checkout == false) {
      this.$router.push("/");
    }
  },
  data() {
    return {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      state: "",
      city: "",
      address: "",
      appartment: "",
      company: "",
      billingErroes: [],
      Error: false,
      successBillingMessage: false,
      paystackkey: "pk_test_18f4e3dec75530f3ce059ff055ae8556bfead856",
      accessCode: "mbclothing" + Math.floor(Math.random() * 1000000000 + 1),
      reference: "mbclothing" + Math.floor(Math.random() * 1000000000 + 1),
      channels: ["card"],
      processing: false,
      processingClearCart: false
    };
  },
  methods: {
    // PROCESS FORM SUBMISSION
    submitBillingForm() {
      // Validate all form inputs

      // remove all errors and messages
      this.billingErroes = [];
      this.successBillingMessage = false;

      // send error message if fields are empty
      if (!this.firstname) {
        this.billingErroes.push("firstname is required");
        return false;
      }
      if (!this.lastname) {
        this.billingErroes.push("lastname is required");
        return false;
      }
      if (!this.email) {
        this.billingErroes.push("E-mail is required");
        return false;
      }

      if (!this.validEmail(this.email)) {
        this.billingErroes.push("Valid email is required");
        return false;
      }

      if (!this.phone) {
        this.billingErroes.push("Phone number is required");
        return false;
      }

      if (isNaN(this.phone)) {
        this.billingErroes.push("Phone number must be number");
        return false;
      }

      if (!this.state) {
        this.billingErroes.push("State is required");
        return false;
      }
      if (!this.city) {
        this.billingErroes.push("City is required");
        return false;
      }

      if (!this.address) {
        this.billingErroes.push("Address is required");
        return false;
      } else {
        let amount = this.cartTotalPrice + this.taxAmount;
        let totalAmountTopay = Math.trunc(amount) * 100;
        this.$store.state.firstname = this.firstname;
        this.$store.state.lastname = this.lastname;
        this.$store.state.email = this.email;
        this.$store.state.amount = totalAmountTopay;
        this.showProcessing();
      }
    },
    // SHOW PROCESSING
    showProcessing: function() {
      this.processing = true;
      setTimeout(() => {
        this.processing = false;
        this.AddToState();
      }, 2600);
    },
    // ADD TO STATE
    AddToState: function() {
      this.processTransaction();
    },
    // PROCESS TRANSACTIONS
    processTransaction: function() {
      // send form if fields are not empty
      this.$store.state.paystackPayment = true;
      this.$store.state.checkoutInfo = true;
      this.$store.state.checkout = true;

      // clear error messages
      this.billingErroes = [];
      this.clearFormMsg();
      // remove success message after 8seconds
      setTimeout(() => (this.successBillingMessage = false), 8000);

      return true;
    },

    // email validation
    validEmail: function(email) {
      var emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      return emailReg.test(email);
    },
    // CANCEL TRANSACTION
    cancelTransaction: function() {
      this.processingClearCart = true;
      setTimeout(() => {
        this.processingClearCart = false;
        this.clearCartState();
      }, 3000);
    },
    // CLEAR START
    clearCartState: function() {
      this.$store.dispatch("clearCart");
      this.$router.push("/");
    },
    // CLEAR FORM INPUTS
    clearFormMsg() {
      this.firstname = "";
      this.lastname = "";
      this.state = "";
      this.city = "";
      this.address = "";
      this.appartment = "";
      this.company = "";
      this.email = "";
      this.phone = "";
      this.message = "";
    },
    // CALL BACK FUNCTION
    callback: function(response) {
      console.log(response);
    },
    close: function() {
      console.log("Payment closed");
    },
    // ADD COMMA TO AMOUNT
    addComma: function(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<style>
.App {
  text-align: center;
  padding-top: 50px;
  padding-bottom: 70px;
}

.App-intro {
  width: 65%;
  margin: auto;
  font-size: large;
  display: flex;
  justify-content: space-around;
}

.payButton {
  color: #fff;
  font-weight: 800;
}
.checkout_btn {
  font-weight: 800;
}

.card .list-group {
  font-family: "Bitter", serif;
}
@media screen and (max-width: 600px) {
  .App {
    padding-top: 20px;
  }
  .App-intro {
    width: 60%;
    display: block;
  }
  .App .list-group {
    text-align: left;
  }

  .payButton {
    margin-bottom: 20px;
    width: 100%;
  }
  .checkout_btn {
    width: 100%;
  }
}
</style>
